import styled from "styled-components";

const ContentView = styled.div`
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
`;

export default ContentView;
